import { useEffect } from 'react';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { HeroSection } from '@/components/home/HeroSection';
import { WhatSection } from '@/components/home/WhatSection';
import { HowSection } from '@/components/home/HowSection';
import { StacksSection } from '@/components/home/StacksSection';
import { PremizeSection } from '@/components/home/PremizeSection';
import { TrainingSection } from '@/components/home/TrainingSection';
import { ProofSection } from '@/components/home/ProofSection';
import { TeamSection } from '@/components/home/TeamSection';
import { CommunitySection } from '@/components/home/CommunitySection';
import { FaqSection } from '@/components/home/FaqSection';
import { ContactSection } from '@/components/home/ContactSection';

/**
 * The whole site: eleven sections in the order a first-time visitor asks
 * questions — what is it, what can it do for me, how does it work, what is it
 * built on, what can I buy, can you teach my team, why trust you, who are you and where, who else is
 * in it with you, the usual questions, how do I start.
 * Section ids are listed in `src/content/site.ts` (SECTION_IDS).
 */
export function Index() {
  // A deep link such as /#stacks scrolls the prerendered HTML to its target,
  // then `createRoot` replaces that DOM and the browser does not scroll again —
  // the visitor lands at the top. Re-apply the hash once React has committed.
  useEffect(() => {
    const id = decodeURIComponent(window.location.hash.slice(1));
    if (id) document.getElementById(id)?.scrollIntoView({ behavior: 'instant' });
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main id="main" className="flex-grow">
        <HeroSection />
        <WhatSection />
        <HowSection />
        <StacksSection />
        <PremizeSection />
        <TrainingSection />
        <ProofSection />
        <TeamSection />
        <CommunitySection />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
